import React from 'react';
import { Modal } from 'react-bootstrap'
import '../css/table-responsive.css'
const ModalOrders = (props) => {
  return (
    <>
      <Modal className='position' title={props.title} show={props.show} fullscreen={true} onHide={props.close}>
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{
            background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
            color: 'white',
            border: 'none',
            padding: '1.25rem 1.75rem',
          }}
        >
          <Modal.Title style={{
            fontFamily: "'Archivo', sans-serif",
            fontWeight: 700,
            fontSize: '1.25rem',
            color: 'white',
          }}>
            {props.title}
          </Modal.Title>
        </Modal.Header>
        {/* TABLEFONTBOOST-2026-10-01 — react-bootstrap's <Modal> always
            renders via a portal to document.body, outside whatever DOM
            subtree the caller's own `zoom` wrapper lives in — so CatalogueV3's
            page-level zoom (SalesOrderV3.js) never reached this content no
            matter where it sat in the React tree. bodyZoom lets a caller
            apply zoom directly on THIS node instead. Optional, defaults to 1
            (no-op) — every other ModalOrders consumer is unaffected. */}
        <Modal.Body style={{ background: '#F8FAFC', padding: '1.5rem', zoom: props.bodyZoom || 1 }}>
          {props.children}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalOrders;